import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";

//TODO implement
const DeleteEventInCalendarApiImpl = async (eventId: string): Promise<Either<ExceptionEntity, void>> => {
    throw new Error("Not implemented");
}

export default DeleteEventInCalendarApiImpl;
